// Keeps the mobile sticky add-to-cart bar (#stickyDiv) in step with the main product form,
// and reveals the dynamic checkout buttons once a size has been chosen.
(() => {
  if (window.__tlSizeSync) return;
  window.__tlSizeSync = true;

  const getSticky = () => document.getElementById('stickyDiv');
  const getMain = () =>
    document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
  const inSticky = (el) => {
    const sticky = getSticky();
    return !!(sticky && sticky.contains(el));
  };
  const selectByName = (root, name) => root.querySelector(`select[name="${CSS.escape(name)}"]`);

  function revealGatedButtons() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      const gate = form.querySelector('[data-size-gated]');
      if (gate && idInput && idInput.value) gate.hidden = false;
    });
  }

  const sizeLabel = () =>
    (document.documentElement.lang || '').toLowerCase().startsWith('pt') ? 'Selecione um tamanho' : 'Select a size';

  // Changing another option (e.g. Gamertag) before a size makes Shopify fall back to the first size.
  // While the size dropdown still shows its placeholder, keep the form unable to add anything.
  function enforceSizeChoice(root) {
    const pendingSize = Array.from(root.querySelectorAll('select[name^="options["]')).find(
      (select) => !select.value && select.querySelector('[data-size-placeholder]')
    );
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!pendingSize || !form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = '';
    const button = form.querySelector('[name="add"]');
    if (button) {
      button.setAttribute('disabled', 'disabled');
      const label = button.querySelector('span');
      if (label) label.textContent = sizeLabel();
    }
    const gate = form.querySelector('[data-size-gated]');
    if (gate) gate.hidden = true;
  }

  function syncSticky() {
    const sticky = getSticky();
    const main = getMain();
    if (main) enforceSizeChoice(main);
    if (!sticky || !main) return revealGatedButtons();

    const mainForm = main.querySelector('form[data-type="add-to-cart-form"]');
    const stickyForm = sticky.querySelector('form[data-type="add-to-cart-form"]');
    if (mainForm && stickyForm) {
      const mainId = mainForm.querySelector('input[name="id"]');
      const stickyId = stickyForm.querySelector('input[name="id"]');
      if (mainId && stickyId) stickyId.value = mainId.value;

      const mainButton = mainForm.querySelector('[name="add"]');
      const stickyButton = stickyForm.querySelector('[name="add"]');
      if (mainButton && stickyButton) {
        stickyButton.toggleAttribute('disabled', mainButton.hasAttribute('disabled'));
        const mainLabel = mainButton.querySelector('span');
        const stickyLabel = stickyButton.querySelector('span');
        if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent;
      }
    }

    main.querySelectorAll('select[name^="options["]').forEach((mainSelect) => {
      const stickySelect = selectByName(sticky, mainSelect.name);
      if (!stickySelect || !mainSelect.value || stickySelect.value === mainSelect.value) return;
      stickySelect.querySelector('[data-size-placeholder]')?.remove();
      stickySelect.value = mainSelect.value;
    });

    revealGatedButtons();
  }

  document.addEventListener('change', (event) => {
    const target = event.target;

    // A choice made in the sticky bar is replayed on the main picker, which drives the product update.
    if (target instanceof HTMLSelectElement && target.name.startsWith('options[') && inSticky(target)) {
      const main = getMain();
      const mainSelect = main && selectByName(main, target.name);
      if (mainSelect && mainSelect.value !== target.value) {
        mainSelect.value = target.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // The main form's variant id changes after each product update; mirror it to the sticky bar.
    if (target instanceof HTMLInputElement && target.name === 'id' && !inSticky(target)) {
      setTimeout(syncSticky, 0);
      setTimeout(syncSticky, 400);
    }
  });
})();
